/* ==========================================================================
   WizeBand Upsell System — wb-upsell.js
   Powers:
     1) PDP "Complete Your 3-for-2 / You May Also Like" section (sections/wb-pdp-upsell.liquid)
     2) Cart-drawer upsell rail (snippets/header-cart-drawer.liquid)
   Uses Shopify's native ML Product Recommendations API — zero maintenance.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function cardHTML(p, opts) {
    opts = opts || {};
    var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^\/\//, 'https://');
    var imgSrc = img ? img.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_400x400$1$2') : '';
    var price = money(p.price, opts.currency);
    var wasPrice = (p.compare_at_price && p.compare_at_price > p.price) ? money(p.compare_at_price, opts.currency) : '';
    var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
    var badge = opts.badge || '';
    return (
      '<a href="' + (p.url || ('/products/' + p.handle)) + '" class="wbu-card" data-wbu-card data-product-id="' + p.id + '">' +
        (badge ? '<span class="wbu-card__badge">' + badge + '</span>' : '') +
        '<span class="wbu-card__img-wrap"><img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400"></span>' +
        '<span class="wbu-card__body">' +
          '<span class="wbu-card__title">' + (p.title || '') + '</span>' +
          '<span class="wbu-card__price-row">' +
            (wasPrice ? '<span class="wbu-card__price-was">' + wasPrice + '</span>' : '') +
            '<span class="wbu-card__price">' + price + '</span>' +
          '</span>' +
          '<span class="wbu-card__add wbu-card__add--link">' + (opts.addLabel || 'Choose Options') + '</span>' +
        '</span>' +
      '</a>'
    );
  }

  function miniCardHTML(p, opts) {
    opts = opts || {};
    var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^\/\//, 'https://');
    var imgSrc = img ? img.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_200x200$1$2') : '';
    var price = money(p.price, opts.currency);
    var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
    return (
      '<div class="wbu-mini" data-product-id="' + p.id + '">' +
        '<a href="' + (p.url || ('/products/' + p.handle)) + '" class="wbu-mini__img"><img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="200" height="200"></a>' +
        '<a href="' + (p.url || ('/products/' + p.handle)) + '" class="wbu-mini__title">' + (p.title || '') + '</a>' +
        '<span class="wbu-mini__price">' + price + '</span>' +
        '<a href="' + (p.url || ('/products/' + p.handle)) + '" class="wbu-mini__add wbu-mini__add--link">Choose</a>' +
      '</div>'
    );
  }

  function fetchRecommendations(productId, limit, intent) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
      '&limit=' + (limit || 8) + '&intent=' + (intent || 'related');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  function excludeIds(list, idsToExclude) {
    var set = new Set((idsToExclude || []).map(String));
    return (list || []).filter(function (p) { return !set.has(String(p.id)); });
  }

  /* ---------------------------------------------------------------- */
  /* PDP SECTION                                                        */
  /* ---------------------------------------------------------------- */
  function initPdpSection(root) {
    var productId = root.getAttribute('data-product-id');
    var currency = root.getAttribute('data-currency');
    if (!productId) return;

    var panels = root.querySelectorAll('[data-wbu-panel]');
    var tabs = root.querySelectorAll('[data-wbu-tab]');
    var loaded = {};

    function loadPanel(intent) {
      if (loaded[intent]) return;
      loaded[intent] = true;
      var panel = root.querySelector('[data-wbu-panel="' + intent + '"]');
      if (!panel) return;
      var rail = panel.querySelector('[data-wbu-rail]');

      fetchRecommendations(productId, 8, intent).then(function (data) {
        var products = data.products || [];
        if (!products.length && intent === 'complementary') {
          // fall back to related if complementary comes back empty
          fetchRecommendations(productId, 8, 'related').then(function (data2) {
            renderRail(rail, data2.products || [], panel, root, currency);
          });
          return;
        }
        renderRail(rail, products, panel, root, currency);
      });
    }

    function renderRail(rail, products, panel, root, currency) {
      if (!products.length) {
        panel.classList.add('is-empty');
        checkAllEmpty();
        return;
      }
      var badge = panel.getAttribute('data-badge') || '';
      rail.innerHTML = products.map(function (p) {
        return cardHTML(p, { currency: currency, badge: badge, addLabel: 'Quick Add' });
      }).join('');
    }

    function checkAllEmpty() {
      var anyVisible = false;
      panels.forEach(function (p) { if (!p.classList.contains('is-empty')) anyVisible = true; });
      if (!anyVisible) root.classList.add('is-empty');
    }

    // Tabs
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var intent = tab.getAttribute('data-wbu-tab');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = root.querySelector('[data-wbu-panel="' + intent + '"]');
        if (panel) panel.classList.add('is-active');
        loadPanel(intent);
      });
    });

    // Load first (active) panel immediately when in view
    var firstIntent = root.getAttribute('data-default-intent') || 'related';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadPanel(firstIntent);
            io.disconnect();
          }
        });
      }, { rootMargin: '400px' });
      io.observe(root);
    } else {
      loadPanel(firstIntent);
    }

    // Quick-add removed 2026-07-07: bands need tone/size selection — cards now link to the PDP.
  }

  function quickAdd(btn, variantId) {
    if (btn.classList.contains('is-loading')) return;
    var originalText = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('is-loading');
        if (data && data.status) {
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = originalText; }, 1600);
          return;
        }
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = originalText;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      });
  }

  /* ---------------------------------------------------------------- */
  /* CART DRAWER UPSELL RAIL                                            */
  /* ---------------------------------------------------------------- */
  var cartRailState = { lastKey: '', loading: false };

  function initCartUpsell() {
    var root = document.querySelector('[data-wbu-cart-upsell]');
    if (!root) return;

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCartUpsell(root, cart); })
        .catch(function () {});
    }

    document.addEventListener('cart:updated', refresh);
    document.addEventListener('ajaxProduct:added', refresh);
    document.addEventListener('drawerOpen', refresh);
    document.addEventListener('cart:build', refresh);

    // Mini quick-add removed 2026-07-07: cards link to the PDP for tone/size selection.

    refresh();
  }

  function renderCartUpsell(root, cart) {
    var head = root.querySelector('[data-wbu-cart-head]');
    var sub = root.querySelector('[data-wbu-cart-sub]');
    var rail = root.querySelector('[data-wbu-cart-rail]');
    if (!rail) return;

    var items = cart.items || [];
    if (!items.length) {
      root.classList.remove('has-items');
      return;
    }

    // 3-for-2 band count logic
    var bandCount = cart.item_count;
    var remainder = bandCount % 3;
    var cyclePos = (bandCount > 0 && remainder === 0) ? 3 : remainder;

    if (cyclePos === 2) {
      if (head) head.innerHTML = '<span class="wbu-gift-emoji">🎁</span> Add a 3rd band — it\'s FREE with 3-for-2!';
      if (sub) sub.textContent = 'You are 1 band away from unlocking your free band.';
    } else if (cyclePos === 1) {
      if (head) head.innerHTML = '<span class="wbu-gift-emoji">✨</span> Add 2 more bands to get one FREE';
      if (sub) sub.textContent = 'Mix & match any bands — 3rd one is on us.';
    } else {
      if (head) head.innerHTML = '<span class="wbu-gift-emoji">✨</span> You may also like';
      if (sub) sub.textContent = 'Frequently added with your picks.';
    }

    // Pick most expensive cart item's product id as the recommendation seed
    var seedProductId = null;
    var maxPrice = -1;
    var inCartProductIds = [];
    items.forEach(function (item) {
      inCartProductIds.push(item.product_id);
      if (item.final_price > maxPrice) {
        maxPrice = item.final_price;
        seedProductId = item.product_id;
      }
    });

    var key = seedProductId + '|' + inCartProductIds.join(',');
    if (cartRailState.lastKey === key && rail.children.length) {
      root.classList.add('has-items');
      return; // avoid redundant refetch/re-render churn
    }

    if (!seedProductId) return;

    fetchRecommendations(seedProductId, 8, 'related').then(function (data) {
      var products = excludeIds(data.products || [], inCartProductIds).slice(0, 6);
      if (!products.length) {
        root.classList.remove('has-items');
        return;
      }
      cartRailState.lastKey = key;
      rail.innerHTML = products.map(function (p) { return miniCardHTML(p, {}); }).join('');
      root.classList.add('has-items');
    });
  }

  /* ---------------------------------------------------------------- */
  /* INIT                                                               */
  /* ---------------------------------------------------------------- */
  function init() {
    document.querySelectorAll('[data-wbu-pdp]').forEach(initPdpSection);
    initCartUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
